// Import new images from NewBanner/Spirits folder
import FirstImage from "assets/NewBanner/Spirits/First.png";
import SecondImage from "assets/NewBanner/Spirits/Second.png";
import ThirdImage from "assets/NewBanner/Spirits/Third.png";
import FourthImage from "assets/NewBanner/Spirits/Fourth.png";

// Import award images
import Gold from "assets/NewBanner/Spirits/Gold.png";
import Silver from "assets/NewBanner/Spirits/Silver.png";
import Bronze from "assets/NewBanner/Spirits/Bronze.png";
import Black from "assets/NewBanner/Spirits/Black.png";

// Import product images
import JamunCoin from "assets/Products/JamunCoin.png";
import PaaniCoin from "assets/Products/PaaniCoin.png";
import BaelCoin from "assets/Products/BaelCoin.png";
import PotatoCoin from "assets/Products/PotatoCoin.png";

import { BASE_IMAGE_URL } from "utils/constants";

export const ourProducts = [
  {
    id: 1,
    image: SecondImage,
    title: "Tharra Jamun",
    linkName: "tharra-jamun",
    percentage: "36% ALC./VOL",
    amount: "$34.99",
    details: [
      "Once cherished by emperors and deities, the Jamun fruit is reimagined in our exquisite Tharra Jamun vodka. Infused with its sweet-tart essence and a blend of secret spices, this vibrant spirit delivers a smooth, tangy finish— reminiscent of the beloved Kala Khatta.",
      " "
    ],

    description:
      "Jamun-infused vodka with sweetness tempered by whispers of exotic spice.",
    btnText: "View Details",
    sideImg: [
      JamunCoin,
      `${BASE_IMAGE_URL}/productDetails/jamun/jamunHalfImage.webp`,
      `${BASE_IMAGE_URL}/productDetails/jamun/jamunVideoImage.webp`
      // jamunDetailImage
    ],
    flavour: "Jamun flavoured ",
    madeIn: "Made in USA",
    litre: "750 Ml",
    awards: [
      {
        title: "San Francisco",
        description: "World Spirits Competition 2025",
        imageSrc: Bronze,
        imageName: "Bronze Medal"
      }
    ]
  },
  {
    id: 2,
    image: FirstImage,
    title: "Tharra Paani",
    linkName: "tharra-paani",
    percentage: "36% ALC./VOL",
    amount: "$34.99",
    details: [
      "Tharra Paani Vodka captures the vibrant essence of India ’ s beloved street food, Pani Puri. Infused with the tangy zest of tamarind, fresh cilantro, cooling mint, sweet date chutney, and a bold kick of spice, each sip delivers a symphony of sweet, sour, spicy, and savory flavors—a true celebration of India ' s culinary spirit.",
      " "
    ],

    description:
      "Experience India's bustling lanes with our Paani Puri-Infused Vodka creation.",
    btnText: "View Details",
    sideImg: [
      PaaniCoin,
      `${BASE_IMAGE_URL}/productDetails/paani/paaniHalfImage.webp`,
      `${BASE_IMAGE_URL}/productDetails/paani/paaniVideoImage.webp`
      // paaniDetailImage
    ],
    flavour: "Paani Puri flavoured ",
    madeIn: "Made in USA",
    litre: "750 Ml",
    awards: [
      {
        title: "American Distilling Institute ",
        description: "Institute International Spirits Competition 2025",
        imageSrc: [Gold, Black],
        imageName: ["Double-Gold  Medal", " Best of Category "]
      },
      {
        title: "San Francisco",
        description: "World Spirits Competition 2025",
        imageSrc: Silver,
        imageName: "Silver Medal"
      }
    ]
  },
  {
    id: 3,
    image: ThirdImage,
    title: "Tharra Bael",
    linkName: "tharra-bael",
    percentage: "36% ALC./VOL",
    amount: "$34.99",
    details: [
      "Tharra Bael Vodka masterfully blends the tangy, sweet, and sour notes of the rare and exotic Bael (Wood Apple) fruit with the crisp purity of finely distilled vodka. An indulgent and unforgettable sensory experience awaits in every pour.",
      " "
    ],

    description:
      "Unveil ancient secrets with our Bael (Wood Apple) Infused Vodka, spiced subtly.",
    btnText: "View Details",
    sideImg: [
      BaelCoin,
      `${BASE_IMAGE_URL}/productDetails/bael/baelHalfImage.webp`,
      `${BASE_IMAGE_URL}/productDetails/bael/baelVideoImage.webp`
      //  baelDetailImage
    ],
    flavour: "Bael flavoured ",
    madeIn: "Made in USA",
    litre: "750 Ml",
    awards: [
      {
        title: "San Francisco",
        description: "World Spirits Competition 2025",
        imageSrc: Bronze,
        imageName: "Bronze Medal"
      }
    ]
  },
  {
    id: 4,
    image: FourthImage,
    title: "Potato Vodka",
    linkName: "potato-vodka",
    percentage: "41% ALC./VOL",
    amount: "$21.99",
    details: [
      "A tribute to purity and craftsmanship, Tharra ’ s Premium Potato Vodka is distilled from the finest Idaho Russet potatoes, celebrated for their rich flavor and creamy texture. Each sip delivers unrivaled smoothness and exceptional quality. ",
      " "
    ],

    description:
      "Pure Potato Vodka crafted from finest russet potatoes for unparalleled quality.",
    btnText: "View Details",
    sideImg: [
      PotatoCoin,
      `${BASE_IMAGE_URL}/productDetails/potato/potatoHalfImage.webp`,
      `${BASE_IMAGE_URL}/productDetails/potato/potatoVideoImage.webp`
      // potatoDetailImage
    ],
    flavour: "Made from Potatoes ",
    madeIn: "Made in USA",
    litre: "750 Ml",
    awards: [
      {
        title: "San Francisco",
        description: "World Spirits Competition 2025",
        imageSrc: Silver,
        imageName: "Silver Medal"
      }
    ]
  }
];
